<footer class="footer-container color-scheme-light">
  <div class="container">
    <div class="main-footer">
      <aside class="footer-sidebar widget-area">
        <div class="row">
        <div class="footer-column footer-column-1 col-md-3 col-sm-6">
          <aside class="footer-widget widget">
            <a routerLink="/" class="site-logo">
              <img [src]="logo" [alt]="displayName" />
            </a>
            <p>
              Cold-air scent machines and fragrance oils for home, car, office, and HVAC.
            </p>
          </aside>
        </div>
        <div class="footer-column footer-column-2 col-md-3 col-sm-6">
          <aside class="footer-widget widget widget_nav_menu">
            <h5 class="widget-title title">Shop</h5>
            <ul class="menu">
              <li><a routerLink="/shop">All products</a></li>
              @for (link of catalog.categoryNav(); track link.label) {
                <li>
                  <a [routerLink]="link.path">{{ link.label }}</a>
                </li>
              }
            </ul>
          </aside>
        </div>
        <div class="footer-column footer-column-3 col-md-3 col-sm-6">
          <aside class="footer-widget widget widget_nav_menu">
            <h5 class="widget-title title">Information</h5>
            <ul class="menu">
              <li><a routerLink="/story">About</a></li>
              <li><a routerLink="/shipping">Shipping policy</a></li>
              <li><a routerLink="/returns">Returns</a></li>
              <li><a routerLink="/privacy">Privacy policy</a></li>
              <li><a routerLink="/terms">Terms of service</a></li>
            </ul>
          </aside>
        </div>
        <div class="footer-column footer-column-4 col-md-3 col-sm-6">
          <aside class="footer-widget widget">
            <h5 class="widget-title title">Contact</h5>
            <ul class="menu">
              <li><a routerLink="/contact">Get in touch</a></li>
              <li>
                <a href="https://www.instagram.com" target="_blank" rel="noreferrer">Instagram</a>
              </li>
              <li>
                <a href="https://www.linkedin.com/" target="_blank" rel="noreferrer">LinkedIn</a>
              </li>
              <li>
                <a href="https://www.facebook.com" target="_blank" rel="noreferrer">Facebook</a>
              </li>
            </ul>
          </aside>
        </div>
        </div>
      </aside>
    </div>
    <div class="copyrights-wrapper">
      <div class="min-footer">
        <div class="col-left">
          <p>© {{ year }} {{ displayName }}. All rights reserved.</p>
        </div>
      </div>
    </div>
  </div>
</footer>
